
(function(){
  if (window.__meEntrega) return; window.__meEntrega = true;
  var DN = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];
  var DL = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
  var MN = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var state = { fecha: '', hora: '', loaded: false, open: false };
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function fmt(d){ return pad(d.getDate()) + '-' + pad(d.getMonth() + 1) + '-' + d.getFullYear(); }
  function iso(d){ return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parse(s){ var m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(s || ''); return m ? new Date(+m[3], +m[2] - 1, +m[1]) : null; }
  function today(){ var t = new Date(); t.setHours(0,0,0,0); return t; }
  function addDays(d, n){ var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function same(a, b){ return a && b && a.getTime() === b.getTime(); }
  function list(s){ return (s || '').split(/[,\n]/).map(function(x){ return x.trim(); }).filter(Boolean); }
  function cfg(root){
    var ds = root.dataset;
    return {
      horas: list(ds.horas),
      mismo: ds.mismoDia === 'true',
      cerr: list(ds.cerrados),
      dsem: list(ds.diasCerrados).map(Number),
      max: parseInt(ds.max, 10) || 30,
      margen: parseInt(ds.margen, 10) || 0
    };
  }
  function hoursFor(c, d){
    if (!d) return [];
    if (!same(d, today())) return c.horas.slice();
    return c.horas.filter(function(h){
      var p = h.split(':'); var t = new Date(); t.setHours(+p[0], +(p[1] || 0), 0, 0);
      return t.getTime() - Date.now() >= c.margen * 60000;
    });
  }
  function dayOk(c, d){
    var t = today();
    if (!d || d < t) return false;
    if (!c.mismo && same(d, t)) return false;
    if (d > addDays(t, c.max)) return false;
    if (c.dsem.indexOf(d.getDay()) > -1) return false;
    if (c.cerr.indexOf(fmt(d)) > -1) return false;
    return hoursFor(c, d).length > 0;
  }
  function chip(cls, html, on, disabled, attrs){
    return '<button type="button" class="me-chip ' + cls + (on ? ' is-on' : '') + '"' + (disabled ? ' disabled' : '') + (on ? ' aria-pressed="true"' : ' aria-pressed="false"') + ' ' + attrs + '>' + html + '</button>';
  }
  function render(root){
    var c = cfg(root), t = today(), sel = parse(state.fecha);
    if (sel && !dayOk(c, sel)) { sel = null; state.fecha = ''; state.hora = ''; }
    var hs = hoursFor(c, sel);
    if (state.hora && hs.indexOf(state.hora) < 0) state.hora = '';
    var days = '', inQuick = false;
    for (var i = 0; i < 3; i++) {
      var d = addDays(t, i), on = same(d, sel); if (on) inQuick = true;
      days += chip('', '<small>' + (i === 0 ? 'Hoy' : DN[d.getDay()]) + '</small><b>' + d.getDate() + '</b>', on, !dayOk(c, d), 'data-me-day="' + fmt(d) + '" aria-label="' + DL[d.getDay()] + ' ' + d.getDate() + '"');
    }
    var otherOn = sel && !inQuick;
    var minD = c.mismo ? t : addDays(t, 1), maxD = addDays(t, c.max);
    days += '<div class="me-chip me-other' + (otherOn ? ' is-on' : '') + '">' + (otherOn ? '<small>' + DN[sel.getDay()] + '</small><b>' + sel.getDate() + '/' + (sel.getMonth() + 1) + '</b>' : '<b>+</b><small>Otra fecha</small>') + '<input type="date" class="me-date-overlay" data-me-date aria-label="Elegir otra fecha" min="' + iso(minD) + '" max="' + iso(maxD) + '"' + (sel ? ' value="' + iso(sel) + '"' : '') + '></div>';
    root.querySelector('[data-me-days]').innerHTML = days;
    var hours = '';
    if (!sel) hours = '<span class="me-hint">Primero elige la fecha.</span>';
    else (same(sel, t) ? hs : c.horas).forEach(function(h){ hours += chip('', h, h === state.hora, hs.indexOf(h) < 0, 'data-me-hour="' + h + '"'); });
    root.querySelector('[data-me-hours]').innerHTML = hours;
    var di = root.querySelector('[data-me-date]');
    di.min = iso(c.mismo ? t : addDays(t, 1)); di.max = iso(addDays(t, c.max));
    if (sel) di.value = iso(sel);
    root.querySelector('[data-me-summary]').textContent = (sel && state.hora) ? (DL[sel.getDay()] + ' ' + sel.getDate() + ' de ' + MN[sel.getMonth()] + ' · ' + state.hora) : '';
    root.querySelector('[data-me-fecha]').value = sel ? state.fecha : '';
    root.querySelector('[data-me-hora]').value = sel ? state.hora : '';
    if (sel && state.hora) { root.classList.remove('has-error'); root.querySelector('[data-me-error]').hidden = true; }
    var cp = root.querySelector('[data-me-compact]');
    if (!cp) { cp = document.createElement('div'); cp.className = 'me-compact'; cp.setAttribute('data-me-compact', ''); root.insertBefore(cp, root.firstChild); }
    var complete = !!(sel && state.hora);
    var collapsed = !!(!state.open && (complete || state.min));
    root.classList.toggle('is-collapsed', collapsed);
    if (collapsed && !complete) {
      cp.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="3"></rect><path d="M3 10h18M8 3v4M16 3v4"></path></svg><span><b>Entrega:</b> elige fecha y hora</span><button type="button" class="me-edit" data-me-edit>Elegir</button>';
    } else if (collapsed) {
      var dd = Math.round((sel - t) / 86400000);
      var lbl = dd === 0 ? 'Hoy ' + sel.getDate() : dd === 1 ? 'Mañana ' + sel.getDate() : DN[sel.getDay()] + ' ' + sel.getDate() + ' ' + MN[sel.getMonth()].slice(0, 3);
      cp.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="3"></rect><path d="M3 10h18M8 3v4M16 3v4"></path></svg><span><b>' + (root.getAttribute('data-tipo') === 'Recoger en sucursal' ? 'Recoger:' : 'Entrega:') + '</b> ' + lbl + ' · ' + state.hora + '</span><button type="button" class="me-edit" data-me-edit>Cambiar</button>';
    } else { cp.innerHTML = ''; }
  }
  function roots(){ return Array.prototype.slice.call(document.querySelectorAll('[data-me-root]')); }
  function renderAll(){ roots().forEach(render); }
  var saveTimer;
  function save(){
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function(){
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { fecha: state.fecha, hora: state.hora } })
      }).catch(function(){});
    }, 250);
  }
  function setFecha(f){
    state.fecha = f;
    var d = parse(f), rs = roots();
    if (d && rs.length && same(d, today())) { var hs = hoursFor(cfg(rs[0]), d); if (hs.indexOf(state.hora) < 0) state.hora = hs[0] || ''; }
    renderAll(); save();
  }
  function init(){
    var rs = roots();
    if (!rs.length) return;
    if (!state.loaded) {
      state.loaded = true;
      state.fecha = rs[0].querySelector('[data-me-fecha]').value || '';
      state.hora = rs[0].querySelector('[data-me-hora]').value || '';
    }
    rs.forEach(function(r){ if (!r.__meInit) { r.__meInit = true; } render(r); });
  }
  document.addEventListener('click', function(e){
    var ov = e.target.closest && e.target.closest('[data-me-date]');
    if (ov) { if (!(window.matchMedia && matchMedia('(pointer: coarse)').matches)) { try { ov.showPicker && ov.showPicker(); } catch (err) {} } return; }
    var b = e.target.closest && e.target.closest('[data-me-root] button');
    if (b) {
      e.preventDefault();
      var root = b.closest('[data-me-root]');
      if (b.hasAttribute('data-me-edit')) { state.open = true; renderAll(); return; }
      if (b.hasAttribute('data-me-day')) { state.open = true; setFecha(b.getAttribute('data-me-day')); return; }
      if (b.hasAttribute('data-me-hour')) { state.hora = b.getAttribute('data-me-hour'); state.open = false; renderAll(); save(); return; }
      if (b.hasAttribute('data-me-other')) {
        var di = root.querySelector('[data-me-date]');
        try { if (di.showPicker) { di.showPicker(); return; } } catch (err) {}
        di.classList.add('is-shown'); di.focus();
      }
      return;
    }
    var co = e.target.closest && e.target.closest('[name="checkout"]');
    if (co) {
      var form = co.form || co.closest('form');
      var root2 = form && form.querySelector('[data-me-root]');
      if (root2 && (!state.fecha || !state.hora)) {
        e.preventDefault(); e.stopPropagation();
        state.open = true; renderAll();
        root2.classList.add('has-error'); root2.querySelector('[data-me-error]').hidden = false;
        root2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, true);
  /* Clic fuera del cuadro: se compacta para ver la bolsa; "Cambiar" lo vuelve a abrir */
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest || t.closest('[data-me-root]')) return;
    if (!document.contains(t)) return;
    var vis = roots().some(function(r){ return r.offsetParent !== null && !r.classList.contains('is-collapsed'); });
    if (!vis) return;
    state.open = false; state.min = true; renderAll();
  });
  document.addEventListener('change', function(e){
    if (!e.target.matches || !e.target.matches('[data-me-date]')) return;
    var v = e.target.value; if (!v) return;
    var p = v.split('-'), d = new Date(+p[0], +p[1] - 1, +p[2]);
    var root = e.target.closest('[data-me-root]'), c = cfg(root);
    e.target.classList.remove('is-shown');
    if (!dayOk(c, d)) {
      var er = root.querySelector('[data-me-error]');
      er.textContent = 'Ese día no hay entregas disponibles. Elige otra fecha.'; er.hidden = false;
      setTimeout(function(){ er.textContent = 'Elige la fecha y la hora de entrega para continuar.'; er.hidden = true; }, 4000);
      return;
    }
    state.open = true; setFecha(fmt(d));
  });
  document.addEventListener('submit', function(e){
    var root = e.target.querySelector && e.target.querySelector('[data-me-root]');
    var sub = e.submitter;
    if (root && sub && sub.name === 'checkout' && (!state.fecha || !state.hora)) {
      e.preventDefault();
      root.classList.add('has-error'); root.querySelector('[data-me-error]').hidden = false;
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function(){
    var pending = roots().some(function(r){ return !r.__meInit; });
    if (pending) init();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Monchys: Envío a domicilio / Recoger en sucursal (se apaga en Configuración del tema > Fecha de entrega) */
(function(){
  if (window.__meTipo) return; window.__meTipo = true;
  var R = 'Recoger en sucursal';
  function apply(root, v){
    root.setAttribute('data-tipo', v);
    root.querySelectorAll('[data-me-tipo]').forEach(function(b){ var on = b.getAttribute('data-me-tipo') === v; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    root.querySelectorAll('[data-me-panel]').forEach(function(p){ p.hidden = p.getAttribute('data-me-panel') !== v; });
    var inp = root.querySelector('[data-me-tipo-input]'); if (inp) inp.value = v;
    var hl = root.querySelector('[data-me-hora-label]'); if (hl) hl.textContent = v === R ? 'Hora en que pasas' : 'Hora';
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-me-tipo]');
    if (!b) return;
    e.preventDefault();
    var v = b.getAttribute('data-me-tipo');
    document.querySelectorAll('[data-me-root]').forEach(function(r){ apply(r, v); });
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { tipo_entrega: v } }) }).catch(function(){});
  });
})();

/* Monchys: en celular, las horas van en carrusel; mantener visible la hora elegida */
(function(){
  if (window.__meHourScroll) return; window.__meHourScroll = true;
  var pending = false;
  function center(){ pending = false; document.querySelectorAll('[data-me-hours]').forEach(function(h){ if (h.scrollWidth <= h.clientWidth + 2) return; var on = h.querySelector('.me-chip.is-on'); if (!on) return; if (h.__meLast === on.textContent) return; h.__meLast = on.textContent; h.scrollLeft = Math.max(0, on.offsetLeft - h.offsetLeft - h.clientWidth / 2 + on.offsetWidth / 2); }); }
  new MutationObserver(function(){ if (!pending) { pending = true; requestAnimationFrame(center); } }).observe(document.documentElement, { childList: true, subtree: true });
})();
